import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEasInfoGroup,
	TEasInfoListRequest,
	TEasInfoListResponsePayload,
	TEasInfoPatchRequest,
	TEasInfoStore,
	TEasInfoUpdateRequest,
} from './types';
import { EAS_INFO_SLICE_NAME } from './constants';

const initialState: TEasInfoStore = {
	easInfoList: null,
	easInfoListLoading: false,
	lastListParams: null,
	groups: null,
	groupsLoading: false,
	patchLoading: false,
	patchSuccess: false,
	updateLoading: false,
	updateSuccess: false,
};

const easInfoSlice = createSlice({
	name: EAS_INFO_SLICE_NAME,
	initialState,
	reducers: {
		getEasInfoListRequest: (state, action: PayloadAction<TEasInfoListRequest | undefined>) => {
			state.easInfoListLoading = true;
			state.lastListParams = action.payload ?? null;
		},
		getEasInfoListSuccess: (state, action: PayloadAction<TEasInfoListResponsePayload>) => {
			state.easInfoList = action.payload;
			state.easInfoListLoading = false;
		},
		getEasInfoListFailure: (state) => {
			state.easInfoListLoading = false;
		},
		clearEasInfoList: (state) => {
			state.easInfoList = null;
		},

		getEasInfoGroupsRequest: (state) => {
			state.groupsLoading = true;
		},
		getEasInfoGroupsSuccess: (state, action: PayloadAction<TEasInfoGroup[]>) => {
			state.groups = action.payload;
			state.groupsLoading = false;
		},
		getEasInfoGroupsFailure: (state) => {
			state.groupsLoading = false;
		},

		patchEasInfoRequest: (state, _action: PayloadAction<TEasInfoPatchRequest>) => {
			state.patchLoading = true;
			state.patchSuccess = false;
		},
		patchEasInfoSuccess: (state) => {
			state.patchLoading = false;
			state.patchSuccess = true;
		},
		patchEasInfoFailure: (state) => {
			state.patchLoading = false;
		},
		resetPatchEasInfoSuccess: (state) => {
			state.patchSuccess = false;
		},

		updateEasInfoRequest: (state, _action: PayloadAction<TEasInfoUpdateRequest>) => {
			state.updateLoading = true;
			state.updateSuccess = false;
		},
		updateEasInfoSuccess: (state) => {
			state.updateLoading = false;
			state.updateSuccess = true;
		},
		updateEasInfoFailure: (state) => {
			state.updateLoading = false;
		},
		resetUpdateEasInfoSuccess: (state) => {
			state.updateSuccess = false;
		},
	},
});

export const {
	getEasInfoListRequest,
	getEasInfoListSuccess,
	getEasInfoListFailure,
	clearEasInfoList,
	getEasInfoGroupsRequest,
	getEasInfoGroupsSuccess,
	getEasInfoGroupsFailure,
	patchEasInfoRequest,
	patchEasInfoSuccess,
	patchEasInfoFailure,
	resetPatchEasInfoSuccess,
	updateEasInfoRequest,
	updateEasInfoSuccess,
	updateEasInfoFailure,
	resetUpdateEasInfoSuccess,
} = easInfoSlice.actions;

export default easInfoSlice.reducer;
